// // import { useState, useEffect } from "react";
// // import instance from "../../lib/axios";

// // export default function CurrencyConverter() {
// //   const [activeTab, setActiveTab] = useState("currency");

// //   const [currencies] = useState([
// //     {
// //       currency: "INR",
// //       image: "/assets/IndiaCurrrency.png",
// //       rate: 1.0,
// //       symbol: "₹",
// //     },
// //     {
// //       currency: "USD",
// //       image: "/assets/USDCurrency.png",
// //       rate: 87.03,
// //       symbol: "$",
// //     },
// //   ]);

// //   const [selectedFromCurrency, setSelectedFromCurrency] = useState(
// //     currencies[1]
// //   );
// //   const [selectedToCurrency, setSelectedToCurrency] = useState(currencies[0]);
// //   const [fromAmount, setFromAmount] = useState(1);
// //   const [toAmount, setToAmount] = useState();
// //   const [exchangeRate, setExchangeRate] = useState(87.03);

// //   const fetchExchangeRate = async (amount, fromCurrency, toCurrency) => {
// //     try {
// //       const response = await instance.post("/api/convert/", {
// //         from_currency: fromCurrency,
// //         to_currency: toCurrency,
// //         is_from_inr: true,
// //         amount: amount,
// //         conversion_type: "Currency",
// //       });

// //       if (response.data.status === "success") {
// //         setExchangeRate(parseFloat(response.data.data.live_rate));
// //         setToAmount(parseFloat(response.data.data.final_amount));
// //       }
// //     } catch (error) {
// //       console.error("Error fetching exchange rate:", error);
// //     }
// //   };

// //   const handleCurrencyChange = (type, e) => {
// //     const newCurrency = currencies.find(
// //       (cur) => cur.currency === e.target.value
// //     );
// //     if (newCurrency) {
// //       if (type === "from") {
// //         setSelectedFromCurrency(newCurrency);
// //       } else {
// //         setSelectedToCurrency(newCurrency);
// //       }
// //       fetchExchangeRate(
// //         fromAmount,
// //         selectedFromCurrency.currency,
// //         selectedToCurrency.currency
// //       );
// //     }
// //   };

// //   const handleFromAmountChange = (e) => {
// //     const newAmount = e.target.value;
// //     setFromAmount(newAmount);
// //     if (selectedFromCurrency.currency !== selectedToCurrency.currency) {
// //       fetchExchangeRate(
// //         newAmount,
// //         selectedFromCurrency.currency,
// //         selectedToCurrency.currency
// //       );
// //     } else {
// //       setToAmount(newAmount);
// //     }
// //   };

// //   const handleToAmountChange = (e) => {
// //     const newAmount = e.target.value;
// //     setToAmount(newAmount);
// //     if (selectedFromCurrency.currency !== selectedToCurrency.currency) {
// //       const inverseRate = 1 / exchangeRate;
// //       const newFromAmount = newAmount * inverseRate;
// //       setFromAmount(newFromAmount);
// //     } else {
// //       setFromAmount(newAmount);
// //     }
// //   };

// //   const handleFromCurrencyChange = (e) => {
// //     const newCurrency = currencies.find(
// //       (cur) => cur.currency === e.target.value
// //     );
// //     if (newCurrency) {
// //       setSelectedFromCurrency(newCurrency);
// //       if (newCurrency.currency !== selectedToCurrency.currency) {
// //         fetchExchangeRate(
// //           fromAmount,
// //           newCurrency.currency,
// //           selectedToCurrency.currency
// //         );
// //       } else {
// //         setToAmount(fromAmount);
// //       }
// //     }
// //   };

// //   const handleToCurrencyChange = (e) => {
// //     const newCurrency = currencies.find(
// //       (cur) => cur.currency === e.target.value
// //     );
// //     if (newCurrency) {
// //       setSelectedToCurrency(newCurrency);
// //       if (newCurrency.currency !== selectedFromCurrency.currency) {
// //         fetchExchangeRate(
// //           fromAmount,
// //           selectedFromCurrency.currency,
// //           newCurrency.currency
// //         );
// //       } else {
// //         setToAmount(fromAmount);
// //       }
// //     }
// //   };

// //   useEffect(() => {
// //     if (selectedFromCurrency.currency !== selectedToCurrency.currency) {
// //       fetchExchangeRate(
// //         fromAmount,
// //         selectedFromCurrency.currency,
// //         selectedToCurrency.currency
// //       );
// //     } else {
// //       setToAmount(fromAmount);
// //     }
// //   }, [selectedFromCurrency, selectedToCurrency]);

// //   return (
// //     <div className="">
// //       <div className="w-full bg-white h-auto py-5 px-8 md:w-[30rem] rounded-lg md:pb-[1.97rem] drop-shadow-[0px_26px_27.6px_#B42330]">
// //         {/* Tabs */}
// //         <div className="flex w-full p-[0.31rem] bg-[#FDFDFD] rounded-lg shadow-[inset_0px_1px_4.5px_0px_rgba(0,0,0,0.17)]">
// //           <button
// //             className={`w-1/3 md:py-3 py-2 text-[0.66625rem] md:text-[0.875rem] rounded-[0.25rem] ${
// //               activeTab === "forex" ? "bg-black text-white" : "text-[#2B2B2B]"
// //             }`}
// //             onClick={() => setActiveTab("forex")}
// //           >
// //             Forex Card
// //           </button>

// //           <button
// //             className={`w-1/3 md:py-3 py-2 text-[0.66625rem] md:text-[0.875rem] rounded-[0.25rem] ${
// //               activeTab === "remittance"
// //                 ? "bg-black text-white"
// //                 : "text-[#2B2B2B]"
// //             }`}
// //             onClick={() => setActiveTab("remittance")}
// //           >
// //             Remittance
// //           </button>

// //           <button
// //             className={`w-1/3 md:py-3 py-2 text-[0.66625rem] md:text-[0.875rem] rounded-[0.25rem] ${
// //               activeTab === "currency"
// //                 ? "bg-black text-white"
// //                 : "text-[#2B2B2B]"
// //             }`}
// //             onClick={() => setActiveTab("currency")}
// //           >
// //             Currency
// //           </button>
// //         </div>
// //         {activeTab === "forex" && (
// //           <div>
// //             <div className="relative">
// //               {/* Red Line Connecting All Divs - positioned behind the elements */}
// //               <div className="absolute top-0 left-[1.9rem] h-full w-[2px] bg-[#FCEBEE] z-0"></div>
// //               <div className="relative z-10">
// //                 <div className="flex justify-between bg-white shadow-[0px_4px_0px_0px_rgba(0,0,0,0.07)] py-[0.625rem] px-4 border border-[#FFDEE4] rounded-[0.25rem] my-6">
// //                   <div className="absolute inset-0 bg-[rgba(255,248,249,0.44)] rounded-[0.25rem]"></div>
// //                   <div className="w-1/2">
// //                     <div className="relative z-10 text-[#505050] text-[0.625rem] text-left font-normal">
// //                       You Want
// //                     </div>
// //                     <div className="relative z-10 flex items-center text-[#0B0B0B] text-base font-bold">
// //                       <span className="text-[0.75rem] md:text-base">
// //                         {selectedFromCurrency.symbol}
// //                       </span>
// //                       <input
// //                         type="number"
// //                         className="w-full text-[0.75rem] md:text-base border-none outline-none appearance-none [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none"
// //                         value={fromAmount}
// //                         onChange={handleFromAmountChange}
// //                       />
// //                     </div>
// //                   </div>
// //                   <div className="relative z-10 w-1/2 flex items-center justify-end">
// //                     <img
// //                       src={selectedToCurrency.image}
// //                       alt={selectedToCurrency.currency}
// //                       className="h-5 w-5 md:w-8 md:h-8"
// //                     />
// //                     <select
// //                       className="text-[0.75rem] md:text-base border-none font-bold p-2 rounded focus:outline-none focus:ring-0"
// //                       value={selectedToCurrency.currency}
// //                       onChange={handleToCurrencyChange}
// //                     >
// //                       {currencies.map((cur) => (
// //                         <option key={cur.currency} value={cur.currency}>
// //                           {cur.currency}
// //                         </option>
// //                       ))}
// //                     </select>
// //                   </div>
// //                 </div>

// //                 <div className="border relative z-50 flex justify-between py-[0.4375rem] px-[0.8125rem] bg-white border-[#FFDEE4] rounded-[0.25rem]">
// //                   {/* Semi-transparent overlay on top of solid background */}
// //                   <div className="absolute inset-0 bg-[rgba(255,248,249,0.44)] rounded-[0.25rem]"></div>

// //                   {/* Content */}
// //                   <div className="relative z-10 text-[#3C3C3C] text-[0.75rem] font-bold">
// //                     83.20 INR
// //                   </div>
// //                   <div className="relative z-10 flex items-center gap-2">
// //                     <div>
// //                       <svg
// //                         xmlns="http://www.w3.org/2000/svg"
// //                         width="7"
// //                         height="7"
// //                         viewBox="0 0 7 7"
// //                         fill="none"
// //                       >
// //                         <circle cx="3.5" cy="3.5" r="3.5" fill="#40C541" />
// //                       </svg>
// //                     </div>
// //                     <div className="text-[#EC5875] text-[0.75rem] font-medium">
// //                       Live Fx Rate
// //                     </div>
// //                   </div>
// //                 </div>

// //                 <div className="relative z-50 flex justify-between py-[0.4375rem] px-[0.8125rem] bg-white border border-[#FFDEE4] rounded-[0.25rem] my-3">
// //                   <div className="absolute inset-0 bg-[rgba(255,248,249,0.44)] rounded-[0.25rem]"></div>
// //                   <div className="relative z-10 text-[#3C3C3C] text-[0.75rem] font-bold">
// //                     0 INR
// //                   </div>
// //                   <div className="relative z-10 text-[#EC5875] text-[0.75rem] font-medium">
// //                     Platform Fees
// //                   </div>
// //                 </div>

// //                 <div className="relative z-50 flex justify-between py-[0.4375rem] px-[0.8125rem] bg-white border border-[#FFDEE4] rounded-[0.25rem] my-3">
// //                   <div className="absolute inset-0 bg-[rgba(255,248,249,0.44)] rounded-[0.25rem]"></div>
// //                   <div className="relative z-10 text-[#3C3C3C] text-[0.75rem] font-bold">
// //                     500 INR
// //                   </div>
// //                   <span className="absolute top-[-21%] left-[6%] z-20">
// //                     <img src="/assets/MinusIcon.png" alt="MinusIcon" />
// //                   </span>
// //                   <div className="relative z-10 text-[#EC5875] text-[0.75rem] font-medium">
// //                     Promotion
// //                   </div>
// //                 </div>

// //                 <div className="relative z-10 border-b-2 border-dashed border-[#FCEBEE] p-2" />

// //                 <div className="relative z-50 flex justify-between py-[0.4375rem] px-[0.8125rem] bg-white border border-[#FFDEE4] rounded-[0.25rem] mt-10">
// //                   <div className="absolute inset-0 bg-[rgba(255,248,249,0.44)] rounded-[0.25rem]"></div>
// //                   <div className="relative z-10 text-[#3C3C3C] text-[0.75rem] font-bold">
// //                     Instant
// //                   </div>
// //                   <span className="absolute top-[-21%] left-[6%] z-20">
// //                     <img src="/assets/LeftArrowIcon.png" alt="LeftArrowIcon" />
// //                   </span>
// //                   <div className="relative z-10 text-[#EC5875] text-[0.75rem] font-medium">
// //                     Delivery
// //                   </div>
// //                 </div>

// //                 <div className="relative z-50 flex justify-between py-[0.4375rem] px-[0.8125rem] bg-[rgba(255,248,249,0.44)] border border-[#FFDEE4] rounded-[0.25rem] mt-3">
// //                   <div className="absolute inset-0 bg-[rgba(255,248,249,0.44)] rounded-[0.25rem]"></div>
// //                   <div className="relative z-10 text-[#3C3C3C] text-[0.75rem] font-bold">
// //                     Online
// //                   </div>
// //                   <span className="absolute top-[-21%] left-[6%] z-20">
// //                     <img src="/assets/EqualIcon.png" alt="EqualIcon" />
// //                   </span>
// //                   <div className="relative z-10 text-[#EC5875] text-[0.75rem] font-medium">
// //                     Payment Mode
// //                   </div>
// //                 </div>

// //                 <div className="relative z-10 flex justify-between bg-white shadow-[0px_4px_0px_0px_rgba(0,0,0,0.07)] py-[0.625rem] px-4 border border-[#FFDEE4] rounded-[0.25rem] my-6">
// //                   <div className="absolute inset-0 bg-[rgba(255,248,249,0.44)] rounded-[0.25rem]"></div>
// //                   <div>
// //                     <div className="relative z-10 text-[#505050] text-[0.625rem] font-normal text-left">
// //                       You have
// //                     </div>
// //                     <div className="relative z-10 text-[#3C3C3C] text-[0.75rem] md:text-base font-bold">
// //                       ₹ 82,700
// //                     </div>
// //                   </div>
// //                   <div className="relative z-10 flex items-center gap-2 md:gap-2">
// //                     <div>
// //                       <img
// //                         src={selectedFromCurrency.image}
// //                         alt={selectedFromCurrency.currency}
// //                         className="w-5 h-5 md:w-8 md:h-8"
// //                       />
// //                     </div>
// //                     {/* <select
// //           className="text-base border-none font-bold p-2 rounded"
// //           value={selectedFromCurrency.currency}
// //           onChange={handleFromCurrencyChange}
// //         >
// //           {currencies.map((cur) => (
// //             <option key={cur.currency} value={cur.currency}>
// //               {cur.currency}
// //             </option>
// //           ))}
// //         </select> */}
// //                     <div className="text-[#1E1E1E] text-[0.75rem] md:text-[1.125rem] font-bold">
// //                       INR
// //                     </div>
// //                   </div>
// //                 </div>
// //               </div>
// //             </div>
// //             <button className="bg-[#DF2D3C] w-full rounded-[0.23794rem] md:rounded-[0.3125rem] text-white font-bold text-[0.66625rem] md:text-[0.875rem] py-[0.57rem] md:py-3 mb-[1.06rem]">
// //               Get Started
// //             </button>
// //             <div className="flex justify-between md:justify-around items-center">
// //               <div className="">
// //                 <h2 className="text-[#1D1D1D] text-center text-[0.625rem] font-normal">
// //                   You could save upto{" "}
// //                   <span className="text-[#DC143C] text-[0.875rem] font-bold">
// //                     ₹2546.20
// //                   </span>
// //                 </h2>
// //               </div>
// //               {/* Vertical Line */}
// //               <div className="h-6 w-[1px] bg-[#CDCDCD]"></div>

// //               <div className="flex justify-around items-center p-[0.625rem] gap-2">
// //                 <svg
// //                   xmlns="http://www.w3.org/2000/svg"
// //                   width="11"
// //                   height="14"
// //                   viewBox="0 0 11 14"
// //                   fill="none"
// //                 >
// //                   <path
// //                     d="M2.83398 5.66667V3.66667C2.83398 2.95942 3.11494 2.28115 3.61503 1.78105C4.11513 1.28095 4.79341 1 5.50065 1C6.2079 1 6.88617 1.28095 7.38627 1.78105C7.88637 2.28115 8.16732 2.95942 8.16732 3.66667V5.66667"
// //                     stroke="black"
// //                     stroke-linecap="round"
// //                   />
// //                   <path
// //                     d="M0.833984 5.66699H10.1673V11.667C10.1673 12.0206 10.0268 12.3598 9.77679 12.6098C9.52674 12.8598 9.18761 13.0003 8.83398 13.0003H2.16732C1.8137 13.0003 1.47456 12.8598 1.22451 12.6098C0.97446 12.3598 0.833984 12.0206 0.833984 11.667V5.66699Z"
// //                     stroke="black"
// //                     stroke-linejoin="round"
// //                   />
// //                   <path
// //                     d="M7.16797 9.33301H7.17464V9.33967H7.16797V9.33301Z"
// //                     stroke="black"
// //                     stroke-width="2.25"
// //                     stroke-linejoin="round"
// //                   />
// //                 </svg>
// //                 <h2 className="text-[#1D1D1D] text-center text-[0.625rem] font-bold">
// //                   24hr Rate Freeze{" "}
// //                   <span className="font-normal">- at No Cost</span>
// //                 </h2>
// //               </div>
// //             </div>
// //           </div>
// //         )}

//         // {activeTab === "remittance" && (
//         //   <div>
//         //     <div className="relative">
//         //       {/* Red Line Connecting All Divs */}
//         //       <div className="absolute top-0 left-[1.9rem] h-full w-[2px] bg-[#FCEBEE] z-[-2]"></div>
//         //       <div className="relative z-10">
//         //         <div className="flex justify-between bg-white shadow-[0px_4px_0px_0px_rgba(0,0,0,0.07)] py-[0.625rem] px-4 border border-[#FFDEE4] rounded-[0.25rem] my-6">
//         //           <div className="absolute inset-0 bg-[rgba(255,248,249,0.44)] rounded-[0.25rem]"></div>
//         //           <div>
//         //             <div className="relative z-10 text-[#505050] text-[0.625rem] font-normal text-left">
//         //               You send
//         //             </div>
//         //             <div className="relative z-10 text-[#3C3C3C] text-[0.75rem] md:text-base font-bold">
//         //               ₹ 1000
//         //             </div>
//         //           </div>
//         //           <div className="relative z-10 flex items-center gap-2 md:gap-2">
//         //             <div>
//         //               <img
//         //                 src="/assets/IndiaCurrrency.png"
//         //                 alt="IndiaCurrrency"
//         //                 className="w-5 h-5 md:w-8 md:h-8"
//         //               />
//         //             </div>
//         //             {/* <select
//         //         className="text-base border-none font-bold p-2 rounded"
//         //         value={selectedFromCurrency.currency}
//         //         onChange={handleFromCurrencyChange}
//         //       >
//         //         {currencies.map((cur) => (
//         //           <option key={cur.currency} value={cur.currency}>
//         //             {cur.currency}
//         //           </option>
//         //         ))}
//         //       </select> */}
//         //             <div className="text-[#1E1E1E] text-[0.75rem] md:text-[1.125rem] font-bold">
//         //               INR
//         //             </div>
//         //           </div>
//         //         </div>

//         //         <div className="border relative z-50 flex justify-between py-[0.4375rem] px-[0.8125rem] bg-white border-[#FFDEE4] rounded-[0.25rem]">
//         //           {/* Semi-transparent overlay on top of solid background */}
//         //           <div className="absolute inset-0 bg-[rgba(255,248,249,0.44)] rounded-[0.25rem]"></div>

//         //           {/* Content */}
//         //           <div className="relative z-10 text-[#3C3C3C] text-[0.75rem] font-bold">
//         //             83.20 INR
//         //           </div>
//         //           <div className="relative z-10 flex items-center gap-2">
//         //             <div>
//         //               <svg
//         //                 xmlns="http://www.w3.org/2000/svg"
//         //                 width="7"
//         //                 height="7"
//         //                 viewBox="0 0 7 7"
//         //                 fill="none"
//         //               >
//         //                 <circle cx="3.5" cy="3.5" r="3.5" fill="#40C541" />
//         //               </svg>
//         //             </div>
//         //             <div className="text-[#EC5875] text-[0.75rem] font-medium">
//         //               Live Fx Rate
//         //             </div>
//         //           </div>
//         //         </div>

//         //         <div className="relative z-50 flex justify-between py-[0.4375rem] px-[0.8125rem] bg-white border border-[#FFDEE4] rounded-[0.25rem] my-3">
//         //           <div className="absolute inset-0 bg-[rgba(255,248,249,0.44)] rounded-[0.25rem]"></div>
//         //           <div className="relative z-10 text-[#3C3C3C] text-[0.75rem] font-bold">
//         //             0 INR
//         //           </div>
//         //           <div className="relative z-10 text-[#EC5875] text-[0.75rem] font-medium">
//         //             Platform Fees
//         //           </div>
//         //         </div>

//         //         <div className="relative z-50 flex justify-between py-[0.4375rem] px-[0.8125rem] bg-white border border-[#FFDEE4] rounded-[0.25rem] my-3">
//         //           <div className="absolute inset-0 bg-[rgba(255,248,249,0.44)] rounded-[0.25rem]"></div>
//         //           <div className="relative z-10 text-[#3C3C3C] text-[0.75rem] font-bold">
//         //             500 INR
//         //           </div>
//         //           <span className="absolute top-[-21%] left-[6%] z-20">
//         //             <img src="/assets/MinusIcon.png" alt="MinusIcon" />
//         //           </span>
//         //           <div className="relative z-10 text-[#EC5875] text-[0.75rem] font-medium">
//         //             Promotion
//         //           </div>
//         //         </div>

//         //         <div className="relative z-10 border-b-2 border-dashed border-[#FCEBEE] p-2" />

//         //         <div className="relative z-50 flex justify-between py-[0.4375rem] px-[0.8125rem] bg-white border border-[#FFDEE4] rounded-[0.25rem] mt-10">
//         //           <div className="absolute inset-0 bg-[rgba(255,248,249,0.44)] rounded-[0.25rem]"></div>
//         //           <div className="relative z-10 text-[#3C3C3C] text-[0.75rem] font-bold">
//         //             Instant
//         //           </div>
//         //           <span className="absolute top-[-21%] left-[6%] z-20">
//         //             <img src="/assets/LeftArrowIcon.png" alt="LeftArrowIcon" />
//         //           </span>
//         //           <div className="relative z-10 text-[#EC5875] text-[0.75rem] font-medium">
//         //             Delivery
//         //           </div>
//         //         </div>

//         //         <div className="relative z-50 flex justify-between py-[0.4375rem] px-[0.8125rem] bg-[rgba(255,248,249,0.44)] border border-[#FFDEE4] rounded-[0.25rem] mt-3">
//         //           <div className="absolute inset-0 bg-[rgba(255,248,249,0.44)] rounded-[0.25rem]"></div>
//         //           <div className="relative z-10 text-[#3C3C3C] text-[0.75rem] font-bold">
//         //             Online
//         //           </div>
//         //           <span className="absolute top-[-21%] left-[6%] z-20">
//         //             <img src="/assets/EqualIcon.png" alt="EqualIcon" />
//         //           </span>
//         //           <div className="relative z-10 text-[#EC5875] text-[0.75rem] font-medium">
//         //             Payment Mode
//         //           </div>
//         //         </div>
//         //         <div className="relative z-50 flex justify-between bg-white shadow-[0px_4px_0px_0px_rgba(0,0,0,0.07)] py-[0.625rem] px-4 border border-[#FFDEE4] rounded-[0.25rem] my-6">
//         //           <div>
//         //             <div className="relative z-10 text-[#505050] text-[0.625rem] font-normal">
//         //               You Want
//         //             </div>
//         //             <div className="relative z-10 text-[#0B0B0B] text-[0.75rem] md:text-base font-bold">
//         //               $ 1000
//         //             </div>
//         //           </div>
//         //           <div className="flex items-center">
//         //             <img
//         //               src={selectedToCurrency.image}
//         //               alt={selectedToCurrency.currency}
//         //               className="w-5 h-5 md:w-8 md:h-8"
//         //             />
//         //             <select
//         //               className="text-[0.75rem] md:text-base border-none font-bold p-2 rounded focus:outline-none focus:ring-0"
//         //               value={selectedToCurrency.currency}
//         //               onChange={handleToCurrencyChange}
//         //             >
//         //               {currencies.map((cur) => (
//         //                 <option key={cur.currency} value={cur.currency}>
//         //                   {cur.currency}
//         //                 </option>
//         //               ))}
//         //             </select>
//         //           </div>
//         //         </div>
//         //       </div>
//         //     </div>
//         //     <button className="bg-[#DF2D3C] w-full rounded-[0.23794rem] md:rounded-[0.3125rem] text-white font-bold text-[0.66625rem] md:text-[0.875rem] py-[0.57rem] md:py-3 mb-[1.06rem]">
//         //       Get Started
//         //     </button>
//         //     <div className="flex justify-around items-center">
//         //       <div className="p-[0.625rem]">
//         //         <h2 className="text-[#1D1D1D] text-center text-[0.625rem] font-normal">
//         //           You could save upto{" "}
//         //           <span className="text-[#DC143C] text-[0.875rem] font-bold">
//         //             ₹2546.20
//         //           </span>
//         //         </h2>
//         //       </div>
//         //       {/* Vertical Line */}
//         //       <div className="h-6 w-[1px] bg-[#CDCDCD]"></div>

//         //       <div className="flex justify-around items-center p-[0.625rem] gap-2">
//         //         <svg
//         //           xmlns="http://www.w3.org/2000/svg"
//         //           width="11"
//         //           height="14"
//         //           viewBox="0 0 11 14"
//         //           fill="none"
//         //         >
//         //           <path
//         //             d="M2.83398 5.66667V3.66667C2.83398 2.95942 3.11494 2.28115 3.61503 1.78105C4.11513 1.28095 4.79341 1 5.50065 1C6.2079 1 6.88617 1.28095 7.38627 1.78105C7.88637 2.28115 8.16732 2.95942 8.16732 3.66667V5.66667"
//         //             stroke="black"
//         //             stroke-linecap="round"
//         //           />
//         //           <path
//         //             d="M0.833984 5.66699H10.1673V11.667C10.1673 12.0206 10.0268 12.3598 9.77679 12.6098C9.52674 12.8598 9.18761 13.0003 8.83398 13.0003H2.16732C1.8137 13.0003 1.47456 12.8598 1.22451 12.6098C0.97446 12.3598 0.833984 12.0206 0.833984 11.667V5.66699Z"
//         //             stroke="black"
//         //             stroke-linejoin="round"
//         //           />
//         //           <path
//         //             d="M7.16797 9.33301H7.17464V9.33967H7.16797V9.33301Z"
//         //             stroke="black"
//         //             stroke-width="2.25"
//         //             stroke-linejoin="round"
//         //           />
//         //         </svg>
//         //         <h2 className="text-[#1D1D1D] text-center text-[0.625rem] font-bold">
//         //           24hr Rate Freeze{" "}
//         //           <span className="font-normal">- at No Cost</span>
//         //         </h2>
//         //       </div>
//         //     </div>
//         //   </div>
//         // )}

// //         {activeTab === "currency" && (
// //           <div>
// //             <div className="relative">
// //               {/* Red Line Connecting All Divs - positioned behind the elements */}
// //               <div className="absolute top-0 left-[1.9rem] h-full w-[2px] bg-[#FCEBEE] z-0"></div>
// //               <div className="relative z-10">
// //                 <div className="flex justify-between bg-white shadow-[0px_4px_0px_0px_rgba(0,0,0,0.07)] py-[0.625rem] px-4 border border-[#FFDEE4] rounded-[0.25rem] my-6">
// //                   <div className="absolute inset-0 bg-[rgba(255,248,249,0.44)] rounded-[0.25rem]"></div>
// //                   <div className="w-1/2">
// //                     <div className="relative z-10 text-[#505050] text-[0.625rem] text-left font-normal">
// //                       You Want
// //                     </div>
// //                     <div className="relative z-10 flex items-center text-[#0B0B0B] text-base font-bold">
// //                       <span className="text-[0.75rem] md:text-base">
// //                         {selectedFromCurrency.symbol}
// //                       </span>
// //                       <input
// //                         type="number"
// //                         className="w-full text-[0.75rem] md:text-base border-none outline-none appearance-none [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none"
// //                         value={fromAmount}
// //                         onChange={handleFromAmountChange}
// //                       />
// //                     </div>
// //                   </div>
// //                   <div className="relative z-10 w-1/2 flex items-center justify-end">
// //                     <img
// //                       src={selectedFromCurrency.image}
// //                       alt={selectedToCurrency.currency}
// //                       className="h-5 w-5 md:w-8 md:h-8"
// //                     />
// //                     <select
// //                       className="text-[0.75rem] md:text-base border-none font-bold p-2 rounded focus:outline-none focus:ring-0"
// //                       value={selectedFromCurrency.currency}
// //                       onChange={(e) => handleCurrencyChange("from", e)}
// //                     >
// //                       {currencies.map((cur) => (
// //                         <option key={cur.currency} value={cur.currency}>
// //                           {cur.currency}
// //                         </option>
// //                       ))}
// //                     </select>
// //                   </div>
// //                 </div>

// //                 <div className="border relative z-50 flex justify-between py-[0.4375rem] px-[0.8125rem] bg-white border-[#FFDEE4] rounded-[0.25rem]">
// //                   {/* Semi-transparent overlay on top of solid background */}
// //                   <div className="absolute inset-0 bg-[rgba(255,248,249,0.44)] rounded-[0.25rem]"></div>

// //                   {/* Content */}
// //                   <div className="relative z-10 text-[#3C3C3C] text-[0.75rem] font-bold">
// //                     83.20 INR
// //                   </div>
// //                   <div className="relative z-10 flex items-center gap-2">
// //                     <div>
// //                       <svg
// //                         xmlns="http://www.w3.org/2000/svg"
// //                         width="7"
// //                         height="7"
// //                         viewBox="0 0 7 7"
// //                         fill="none"
// //                       >
// //                         <circle cx="3.5" cy="3.5" r="3.5" fill="#40C541" />
// //                       </svg>
// //                     </div>
// //                     <div className="text-[#EC5875] text-[0.75rem] font-medium">
// //                       Live Fx Rate
// //                     </div>
// //                   </div>
// //                 </div>

// //                 <div className="relative z-50 flex justify-between py-[0.4375rem] px-[0.8125rem] bg-white border border-[#FFDEE4] rounded-[0.25rem] my-3">
// //                   <div className="absolute inset-0 bg-[rgba(255,248,249,0.44)] rounded-[0.25rem]"></div>
// //                   <div className="relative z-10 text-[#3C3C3C] text-[0.75rem] font-bold">
// //                     0 INR
// //                   </div>
// //                   <div className="relative z-10 text-[#EC5875] text-[0.75rem] font-medium">
// //                     Platform Fees
// //                   </div>
// //                 </div>

// //                 <div className="relative z-50 flex justify-between py-[0.4375rem] px-[0.8125rem] bg-white border border-[#FFDEE4] rounded-[0.25rem] my-3">
// //                   <div className="absolute inset-0 bg-[rgba(255,248,249,0.44)] rounded-[0.25rem]"></div>
// //                   <div className="relative z-10 text-[#3C3C3C] text-[0.75rem] font-bold">
// //                     500 INR
// //                   </div>
// //                   <span className="absolute top-[-21%] left-[6%] z-20">
// //                     <img src="/assets/MinusIcon.png" alt="MinusIcon" />
// //                   </span>
// //                   <div className="relative z-10 text-[#EC5875] text-[0.75rem] font-medium">
// //                     Promotion
// //                   </div>
// //                 </div>

// //                 <div className="relative z-10 border-b-2 border-dashed border-[#FCEBEE] p-2" />

// //                 <div className="relative z-50 flex justify-between py-[0.4375rem] px-[0.8125rem] bg-white border border-[#FFDEE4] rounded-[0.25rem] mt-10">
// //                   <div className="absolute inset-0 bg-[rgba(255,248,249,0.44)] rounded-[0.25rem]"></div>
// //                   <div className="relative z-10 text-[#3C3C3C] text-[0.75rem] font-bold">
// //                     Instant
// //                   </div>
// //                   <span className="absolute top-[-21%] left-[6%] z-20">
// //                     <img src="/assets/LeftArrowIcon.png" alt="LeftArrowIcon" />
// //                   </span>
// //                   <div className="relative z-10 text-[#EC5875] text-[0.75rem] font-medium">
// //                     Delivery
// //                   </div>
// //                 </div>

// //                 <div className="relative z-50 flex justify-between py-[0.4375rem] px-[0.8125rem] bg-[rgba(255,248,249,0.44)] border border-[#FFDEE4] rounded-[0.25rem] mt-3">
// //                   <div className="absolute inset-0 bg-[rgba(255,248,249,0.44)] rounded-[0.25rem]"></div>
// //                   <div className="relative z-10 text-[#3C3C3C] text-[0.75rem] font-bold">
// //                     Online
// //                   </div>
// //                   <span className="absolute top-[-21%] left-[6%] z-20">
// //                     <img src="/assets/EqualIcon.png" alt="EqualIcon" />
// //                   </span>
// //                   <div className="relative z-10 text-[#EC5875] text-[0.75rem] font-medium">
// //                     Payment Mode
// //                   </div>
// //                 </div>

// //                 <div className="relative z-10 flex justify-between bg-white shadow-[0px_4px_0px_0px_rgba(0,0,0,0.07)] py-[0.625rem] px-4 border border-[#FFDEE4] rounded-[0.25rem] my-6">
// //                   <div className="absolute inset-0 bg-[rgba(255,248,249,0.44)] rounded-[0.25rem]"></div>
// //                   <div>
// //                     <div className="relative z-10 text-[#505050] text-[0.625rem] font-normal text-left">
// //                       You have
// //                     </div>
// //                     <div className="relative z-10 text-[#3C3C3C] text-[0.75rem] md:text-base font-bold">
// //                       ₹{exchangeRate}
// //                     </div>
// //                   </div>
// //                   <div className="relative z-10 flex items-center gap-2 md:gap-2">
// //                     <div>
// //                       <img
// //                         src="/assets/IndiaCurrrency.png"
// //                         alt="IndiaCurrrency"
// //                         className="w-5 h-5 md:w-8 md:h-8"
// //                       />
// //                     </div>
// //                     {/* <select
// //                       className="text-base border-none font-bold p-2 rounded"
// //                       value={selectedFromCurrency.currency}
// //                       onChange={handleFromCurrencyChange}
// //                     >
// //                       {currencies.map((cur) => (
// //                         <option key={cur.currency} value={cur.currency}>
// //                           {cur.currency}
// //                         </option>
// //                       ))}
// //                     </select> */}
// //                     <div className="text-[#1E1E1E] text-[0.75rem] md:text-[1.125rem] font-bold">
// //                       INR
// //                     </div>
// //                   </div>
// //                 </div>
// //               </div>
// //             </div>
// //             <button className="bg-[#DF2D3C] w-full rounded-[0.23794rem] md:rounded-[0.3125rem] text-white font-bold text-[0.66625rem] md:text-[0.875rem] py-[0.57rem] md:py-3 mb-[1.06rem]">
// //               Get Started
// //             </button>
// //             <div className="flex justify-between md:justify-around items-center">
// //               <div className="">
// //                 <h2 className="text-[#1D1D1D] text-center text-[0.625rem] font-normal">
// //                   You could save upto{" "}
// //                   <span className="text-[#DC143C] text-[0.875rem] font-bold">
// //                     ₹2546.20
// //                   </span>
// //                 </h2>
// //               </div>
// //               {/* Vertical Line */}
// //               <div className="h-6 w-[1px] bg-[#CDCDCD]"></div>

// //               <div className="flex justify-around items-center p-[0.625rem] gap-2">
// //                 <svg
// //                   xmlns="http://www.w3.org/2000/svg"
// //                   width="11"
// //                   height="14"
// //                   viewBox="0 0 11 14"
// //                   fill="none"
// //                 >
// //                   <path
// //                     d="M2.83398 5.66667V3.66667C2.83398 2.95942 3.11494 2.28115 3.61503 1.78105C4.11513 1.28095 4.79341 1 5.50065 1C6.2079 1 6.88617 1.28095 7.38627 1.78105C7.88637 2.28115 8.16732 2.95942 8.16732 3.66667V5.66667"
// //                     stroke="black"
// //                     stroke-linecap="round"
// //                   />
// //                   <path
// //                     d="M0.833984 5.66699H10.1673V11.667C10.1673 12.0206 10.0268 12.3598 9.77679 12.6098C9.52674 12.8598 9.18761 13.0003 8.83398 13.0003H2.16732C1.8137 13.0003 1.47456 12.8598 1.22451 12.6098C0.97446 12.3598 0.833984 12.0206 0.833984 11.667V5.66699Z"
// //                     stroke="black"
// //                     stroke-linejoin="round"
// //                   />
// //                   <path
// //                     d="M7.16797 9.33301H7.17464V9.33967H7.16797V9.33301Z"
// //                     stroke="black"
// //                     stroke-width="2.25"
// //                     stroke-linejoin="round"
// //                   />
// //                 </svg>
// //                 <h2 className="text-[#1D1D1D] text-center text-[0.625rem] font-bold">
// //                   24hr Rate Freeze{" "}
// //                   <span className="font-normal">- at No Cost</span>
// //                 </h2>
// //               </div>
// //             </div>
// //           </div>
// //         )}
// //       </div>
// //     </div>
// //   );
// // }

// import React from 'react';
// import './SlidingAnimation.css';

// const ScrollingImages = () => {
//   return (
//     <div className="sliding-container">
//       <div className="column">
//         <div className="sliding-track track-1">
//           <div className="sliding-content">
//             <div className="div-item">
//               <img src='/assets/Group1.svg' alt='Group1'/>
//             </div>
//             <div className="div-item">
//             <img src='/assets/Group1.svg' alt='Group1'/>
//             </div>
//             <div className="div-item">
//             <img src='/assets/Group1.svg' alt='Group1'/>
//             </div>
//             <div className="div-item">
//             <img src='/assets/Group1.svg' alt='Group1'/>
//             </div>
//             <div className="div-item">
//             <img src='/assets/Group1.svg' alt='Group1'/>
//             </div>
//           </div>
//           <div className="sliding-content">
//             <div className="div-item"><img src='/assets/Group1.svg' alt='Group1'/></div>
//             <div className="div-item"><img src='/assets/Group1.svg' alt='Group1'/></div>
//             <div className="div-item"><img src='/assets/Group1.svg' alt='Group1'/></div>
//             <div className="div-item"><img src='/assets/Group1.svg' alt='Group1'/></div>
//             <div className="div-item"><img src='/assets/Group1.svg' alt='Group1'/></div>
//           </div>
//         </div>
//       </div>

//       <div className="column">
//         <div className="sliding-track track-2">
//           <div className="sliding-content">
//           <div className="div-item"><img src='/assets/Group1.svg' alt='Group1'/></div>
//             <div className="div-item"><img src='/assets/Group1.svg' alt='Group1'/></div>
//             <div className="div-item"><img src='/assets/Group1.svg' alt='Group1'/></div>
//             <div className="div-item"><img src='/assets/Group1.svg' alt='Group1'/></div>
//             <div className="div-item"><img src='/assets/Group1.svg' alt='Group1'/></div>
//           </div>
//           <div className="sliding-content">
//           <div className="div-item"><img src='/assets/Group1.svg' alt='Group1'/></div>
//             <div className="div-item"><img src='/assets/Group1.svg' alt='Group1'/></div>
//             <div className="div-item"><img src='/assets/Group1.svg' alt='Group1'/></div>
//             <div className="div-item"><img src='/assets/Group1.svg' alt='Group1'/></div>
//             <div className="div-item"><img src='/assets/Group1.svg' alt='Group1'/></div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ScrollingImages;

import { cn } from "../../lib/utils";
import Marquee from "../utils/Marquee";
import CustomMotionComponent from "../utils/Motion";

const reviews = [
  {
    id: 1,
    img: "/assets/Group1.svg",
  },
  {
    id: 2,
    img: "/assets/Group2.svg",
  },
  {
    id: 3,
    img: "/assets/Group3.svg",
  },
  {
    id: 4,
    img: "/assets/Group4.svg",
  },
  {
    id: 5,
    img: "/assets/Group5.svg",
  },
  {
    id: 6,
    img: "/assets/Group6.svg",
  },
];

const firstRow = [...reviews]; // 1 to 6
const secondRow = [...reviews].reverse();

const ReviewCard = ({ img }) => {
  return (
    <div className="relative w-full overflow-hidden perspective-1000">
      <img
        className="w-20 h-20 md:w-40 md:h-40 transform transition-transform duration-500 rotate-x-[30deg] rotate-y-[-20deg] shadow-lg"
        alt="3D Effect"
        src={img}
      />
    </div>
  );
};

export function ScrollingImages() {
  return (
    <CustomMotionComponent>
      <div
        className="relative text-white h-[325px]  md:h-[543px] overflow-hidden"
        id="Testimonials"
      >
        <div className="h-[300px] md:h-[800px] flex items-center justify-center overflow-hidden">
          {/* Gradient overlay for top and bottom opacity */}
        <div className="absolute top-0 left-0 w-full h-full pointer-events-none">
          <div className="absolute top-0 w-full h-24 bg-gradient-to-b from-white to-transparent z-50"></div>
          <div className="absolute bottom-0 w-full h-24 bg-gradient-to-t from-white to-transparent z-50"></div>
        </div>
          {/* Tilting the entire row of marquee */}
          <div className="rotate-[20deg] flex gap-2">
            <div>
              <Marquee pauseOnHover vertical className="[--duration30s]">
                {firstRow.map((review, i) => (
                  <ReviewCard key={i} {...review} />
                ))}
              </Marquee>
            </div>

            <div>
              <Marquee
                reverse
                pauseOnHover
                vertical
                className="[--duration:30s]"
              >
                {secondRow.map((review, i) => (
                  <ReviewCard key={i} {...review} />
                ))}
              </Marquee>
            </div>
          </div>
        </div>
      </div>
    </CustomMotionComponent>
  );
}
